export const LOGIN = '@@auth/LOGIN';
export const LOGIN_FACEBOOK = '@@auth/LOGIN_FACEBOOK';
export const LOGIN_GOOGLE = '@@auth/LOGIN_GOOGLE';
export const LOGIN_LINKEDIN = '@@auth/LOGIN_LINKEDIN';
export const LOGOUT = '@@auth/LOGOUT';
export const UNAUTHORIZED = '@@auth/UNAUTHORIZED';
export const UPDATE_PROFILE = '@@auth/UPDATE_PROFILE';
export const UPDATE_SESSION_EXPIRED = '@@auth/UPDATE_SESSION_EXPIRED';
